var map = {
	"./img-restaurante-logo-103.png": 2749,
	"./img-restaurante-logo-104.png": 4850,
	"./img-restaurante-logo-155.png": 3384,
	"./img-restaurante-logo-5.png": 8922,
	"./img-restaurante-logo-6.png": 3681,
	"./img-restaurante-logo-7.png": 9816,
	"./img-restaurante-logo-8.png": 9663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 586;